
export default {
    all: function (state) {
        return state.snacks
    }
}